var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconrefer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#D0D3DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7735 9.901L11.362 12.0959C11.1951 12.2471 10.9379 12.2358 10.7868 12.0689C10.7191 11.9944 10.6807 11.8952 10.6807 11.7936V11.1282H9.70171C9.09715 11.1282 8.4971 11.5387 8.04819 12.2561L7.68274 13.0298C7.61507 13.172 7.47295 13.2622 7.31504 13.2644C7.28572 13.2644 7.25414 13.2622 7.22481 13.2554C7.03983 13.2126 6.90674 13.0479 6.90674 12.8584C6.90674 10.1198 8.18354 8.13017 9.94309 8.13017H10.683V7.40831C10.683 7.18272 10.8657 7 11.0891 7C11.1906 7 11.2898 7.03835 11.3643 7.10602L13.7735 9.29869C13.9404 9.44983 13.9517 9.70926 13.8006 9.87393C13.7915 9.88521 13.7825 9.89423 13.7735 9.901Z",
    fill: "#8A92A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconrefer);
export default __webpack_public_path__ + "static/media/Icon.refer.b367386ef6fe51a0b497fccccfedb5af.svg";
export { ForwardRef as ReactComponent };